$(document).ready(function() {
    if ($(".atb_carousel").length > 0) {
      $(".atb_carousel").slick({
        infinite: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        dots: false,
          responsive: [
          {
            breakpoint: 767,
            settings: {
              adaptiveHeight: true
            }
          }
        ]
      }); 
    }
    if ($(".reviews_carousel").length > 0) {
      $(".reviews_carousel").slick({
        infinite: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        dots: false,
        adaptiveHeight: true
      });
    }
    if ($(".categories_carousel").length > 0) {
      $(".categories_carousel").slick({
        infinite: true,
        slidesToShow: 2,
        slidesToScroll: 1,
        arrows: true,
        dots: false,
          responsive: [
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1
            }
          }
        ]
      });
    }
    if ($(".baby_product_wrap").length > 0) {
      $(".baby_product_wrap").slick({
        infinite: false,
        slidesToShow: 3,
        slidesToScroll: 1,
        arrows: true,
        dots: false,
          responsive: [
          {
            breakpoint: 821,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1
            }
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1
            }
          }
        ]
      });
    }



window.addEventListener("klaviyoForms", function(e) {
    if (e.detail.type == 'submit' && e.detail.formId == 'QPM9Nu' ) {
      $('.klaviyo-form-QPM9Nu form').addClass('form-submit');
    }
});

$(this).scrollTop(0);  

});

$(window).on("load", function(){
  //$(".price-wrap").insertAfter("h2.product-title");
  if($("body").hasClass("template-product")) {
    setTimeout(function(){
      console.log(window.yotpo.widgets[0].sources.reviews.content.length);
      if(window.yotpo.widgets[0].sources.reviews.content.length == 0) {
        $(".review-wrap").addClass("no-reviews");
      }
    },1000);
  }
});

$(document).on("click", ".price-wrap .reviews-badge, .yotpo-display-wrapper", function(event){
  if($("body").hasClass('template-product')){
    event.preventDefault();
    event.stopPropagation();
    $('html, body').animate({
          scrollTop: $("#shopify-product-reviews").offset().top
      }, 2000);
  }
});

$(document).on("click", ".custom_category_nav button", function(){
  if($(this).hasClass("slick-prev")) {
    $(".categories_carousel").slick('slickPrev');
  }
  else {
    $(".categories_carousel").slick('slickNext');
  }
});  
